import { Route, Switch, useLocation } from 'react-router-dom';
import { Front, Layout } from './components/Layout';
import { Navigation } from './features/navigation/Navigation';
import { TopPanel } from './features/top/TopPanel';
import { PageContentContainer } from './features/content/PageContentContainer';
import { DashboardContainer } from './features/dashboard/DashboardContainer';
import { ActionFormContainer } from './features/forms/ActionFormContainer';
import { LoginContainer } from './features/login/LoginContainer';
import { NotificationContainer } from './features/notifications/NotificationContainer';
import { LogoutPage } from './features/login/Logout';
import { PrivateRoute } from './features/login/PrivateRoute';
import { DetailsContainer } from './features/details/DetailsContainer';
import { AuditDashboard } from './features/audit/AuditDashboard';

const App = () => {
    const location = useLocation().pathname;
    return (
        <Layout>
            <Navigation />
            <Layout direction="column">
                {location !== "/login" && location !== "/logout" && <TopPanel />}
                <Switch>
                    <Route path="/login" component={LoginContainer} />
                    <Route path="/logout" component={LogoutPage} />
                    <PrivateRoute exact path="/" component={DashboardContainer} />
                    <PrivateRoute path="/dashboard" component={DashboardContainer} />
                    <PrivateRoute exact path="/organisations/:org/:tab" component={PageContentContainer} />
                    <PrivateRoute exact path="/organisations/:org" component={DetailsContainer} />
                    <PrivateRoute exact path="/organisations/:org/:tab/:selected" component={DetailsContainer} />
                    <PrivateRoute exact path="/audit" component={AuditDashboard} />
                    <PrivateRoute exact path="/audit/:tab" component={PageContentContainer} />
                    <PrivateRoute exact path="/audit/:tab/:selected" component={DetailsContainer} />
                    <PrivateRoute exact path="/:tab" component={PageContentContainer} />
                    <PrivateRoute path="/:tab/:selected" component={DetailsContainer} />
                </Switch>
                <Front>
                    <NotificationContainer />
                </Front>
                <ActionFormContainer />
            </Layout>
        </Layout>
    );
}

export default App;
